<!-- Settings and Controls -->
<div
  *ngIf="showSettings && data?.length"
  class="d-flex justify-content-between align-items-center mb-2 flex-wrap"
>
  <button
    mat-icon-button
    [matMenuTriggerFor]="settingsMenu"
    aria-label="Configurações de colunas"
    class="me-2"
  >
    <mat-icon>settings</mat-icon>
  </button>

  <mat-menu #settingsMenu="matMenu" color="primary" panelClass="columns-menu">
    <ng-container *ngFor="let col of columns">
      <ng-container *ngIf="col.field !== 'actions'">
        <mat-menu-item (click)="$event.stopPropagation()">
          <mat-checkbox
            [(ngModel)]="col.visible"
            [disabled]="col.alwaysVisible ?? false"
            (ngModelChange)="onColumnToggle(col)"
            disableRipple
            class="w-100"
          >
            <span class="text-black text-nowrap">
              {{ col.label | translate }}
            </span>
          </mat-checkbox>
        </mat-menu-item>
      </ng-container>
    </ng-container>
  </mat-menu>
</div>

<!-- Responsive Table Container -->
<div class="table-responsive" *ngIf="data?.length" [ngClass]="customClass">
  <table
    class="table display mb-4 dataTablesCard dataTable table-hover"
    [ngClass]="customClassTable"
    [id]="tableId"
    matSort
    (matSortChange)="onSortChange($event)"
  >
    <thead>
      <tr>
        <th
          *ngIf="showExpandColumn && rowDetailTpl"
          class="text-center"
          style="width: 50px"
        >
          <span class="d-none d-sm-inline">Expandir</span>
        </th>

        <th *ngIf="hasCheckbox" class="text-center" style="width: 50px">
          <div class="checkbox text-center align-self-center">
            <input
              (click)="checkUncheckAll()"
              class="form-check-input"
              type="checkbox"
              id="checkAll"
            />
            <label class="form-check-label" for="checkAll"> </label>
          </div>
        </th>

        <ng-container *ngFor="let col of columns; trackBy: trackByField">
          <th
            *ngIf="
              (col.alwaysVisible && col.field !== 'actions') ||
              (col.visible && col.field !== 'actions')
            "
            class="text-nowrap"
            style="min-width: 50px"
          >
            <span class="d-none d-md-inline" *ngIf="col.label">{{
              col?.label || '' | translate
            }}</span>
            <span class="d-md-none"
              >{{ col?.label || '' | slice : 0 : 8
              }}{{ (col?.label?.length || 0) > 8 ? '...' : '' }}</span
            >
          </th>

          <th
            *ngIf="col.field === 'actions'"
            class="text-center"
            style="width: 80px"
          >
            <span class="d-sm-inline">{{ col.label || '' | translate }}</span>
          </th>
        </ng-container>
      </tr>
    </thead>

    <tbody>
      <ng-container *ngFor="let row of data; let i = index">
        <tr>
          <td
            *ngIf="showExpandColumn && rowDetailTpl"
            class="expander-cell text-center"
          >
            <button
              type="button"
              class="btn btn-link p-1"
              [disabled]="!canExpandRow(row, i)"
              (click)="toggleExpand(row, i)"
              [attr.aria-expanded]="isExpanded(row, i)"
              [attr.aria-label]="isExpanded(row, i) ? 'Recolher' : 'Expandir'"
            >
              <gatewee-icon
                [icon]="
                  isExpanded(row, i) ? '@phi.caret-down' : '@phi.caret-right'
                "
                size="16px"
              ></gatewee-icon>
            </button>
          </td>

          <td *ngIf="hasCheckbox" class="text-center">
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="selectAll"
            />
          </td>

          <ng-container *ngFor="let col of columns; trackBy: trackByField">
            <td
              *ngIf="
                (col.alwaysVisible && col.field !== 'actions') ||
                (col.visible && col.field !== 'actions')
              "
              class="text-truncate"
              [style.max-width]="'250px'"
            >
              <ng-container *ngIf="!col.template; else customTpl">
                <ng-container *ngIf="col.badge; else plainValue">
                  <span
                    class="badge badge-sm light"
                    [ngClass]="
                      getStatusClass(getValueFromPath(row, col.field, true))
                    "
                  >
                    {{ getValueFromPath(row, col.field) | translate }}
                  </span>
                </ng-container>

                <ng-template #plainValue>
                  <ng-container *ngIf="col.hrefField; else noLink">
                    <a
                      [href]="getValueFromPath(row, col.hrefField)"
                      target="_blank"
                      rel="noopener noreferrer"
                      [ngClass]="col.class"
                      [class.gw-ellipsis]="col.ellipsed"
                      [matTooltip]="
                        col.ellipsed
                          ? getValueFromPath(row, col.field) || '-'
                          : ''
                      "
                      matTooltipShowDelay="300"
                      [innerHTML]="
                        getValueFromPath(row, col.field) || '-' | translate
                      "
                    >
                    </a>
                  </ng-container>

                  <ng-template #noLink>
                    <span
                      [ngClass]="col.class"
                      [class.gw-ellipsis]="col.ellipsed"
                      [matTooltip]="
                        col.ellipsed
                          ? getValueFromPath(row, col.field) || '-'
                          : ''
                      "
                      [innerHTML]="
                        getValueFromPath(row, col.field) || '-' | translate
                      "
                    >
                    </span>
                  </ng-template>
                </ng-template>
              </ng-container>

              <ng-template #customTpl>
                <ng-container
                  *ngTemplateOutlet="
                    col.template;
                    context: {$implicit: row, col: col}
                  "
                >
                </ng-container>
              </ng-template>
            </td>

            <td
              *ngIf="col.field === 'actions'"
              class="text-center"
              style="width: 80px"
            >
              <button
                mat-icon-button
                [matMenuTriggerFor]="rowMenu"
                [matMenuTriggerData]="{row: row}"
                aria-label="Ações"
                class="btn-sm"
                *ngIf="hasMenu(row)"
              >
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu
                panelClass="gatewee-table-menu"
                #rowMenu="matMenu"
                xPosition="before"
                yPosition="below"
              >
                <ng-template matMenuContent let-data="data">
                  <div *ngFor="let action of col.actions || []">
                    <button
                      mat-menu-item
                      (click)="onActionClick(row, action)"
                      [class.text-danger]="action.danger"
                      [disabled]="action.disabled"
                      *ngIf="
                        !action.condition ||
                        evaluateActionCondition(row, action)
                      "
                    >
                      <gatewee-icon
                        *ngIf="action.icon"
                        [icon]="action.icon"
                        size="16px"
                        class="me-2"
                      ></gatewee-icon>
                      <span>{{ action.label | translate }}</span>
                    </button>
                  </div>
                </ng-template>
              </mat-menu>
            </td>
          </ng-container>
        </tr>

        <tr *ngIf="isExpanded(row, i)">
          <td [attr.colspan]="12" class="p-0">
            <div class="expand-wrapper">
              <ng-container
                *ngTemplateOutlet="rowDetailTpl; context: {$implicit: row}"
              ></ng-container>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<!-- Pagination Section -->
<div
  class="d-flex flex-column flex-sm-row justify-content-between align-items-center"
  *ngIf="data?.length"
>
  <div class="mb-2 mb-sm-0">
    <div class="mb-2 text-center text-sm-start">
      <small class="text-muted">{{ getSummary() }}</small>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <app-custom-pagination
      *ngIf="totalPages > 1"
      [totalPage]="totalPages"
      [page]="page"
      (newPage)="pageChange($event)"
    >
    </app-custom-pagination>
  </div>
</div>

<div class="text-center text-muted py-5" *ngIf="!data?.length">
  {{ 'common.dataNotFound' | translate }}
</div>
